import React from 'react';

import {LogoImageParams} from "./models/logo.image-params";
import {Image} from "../image/image";
import {AppTerms} from "../../app/app-terms";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {LogoMetadataModel} from "./models/logo.metadata-model";
import {WithDevice} from "../composers/with-device";
import {DeviceViewModel} from "../../models/device.view-model";
import {WithTerms} from "../composers/with-terms";

export class LogoComponentProps extends BaseProps {
  device: DeviceViewModel;
  width: Number = 115;
  height: Number = 65;
  i18n: AppTerms;
}

export const Logo = WithTerms(WithDevice((props: LogoComponentProps) => {
  const logoMetaData: LogoMetadataModel = new LogoMetadataModel(null, props.i18n);
  const logoImageParams: LogoImageParams = new LogoImageParams(logoMetaData, props.width, props.height, props.device.isSmallView ? 3 : 1);

  const containerProps = {
    className: ['logo-container', props.className].join(' '),
    style: props.style
  }

  return (
    <div {...containerProps}>
      <Image src={logoImageParams} style={{width: props.width, height: props.height}}/>
    </div>
  )
}));
